<template>
  <div class="planificaciones-dashboard">
    <!-- Header con filtros y botón agregar -->
    <div class="dashboard-header">
      <div class="header-content">
        <div class="header-title-section">
          <h1 class="dashboard-title">
            <svg class="title-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
            Planificaciones
          </h1>

          <!-- Botón agregar compacto -->
          <button @click="abrirModalAgregar" class="btn-add-compact">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
            </svg>
            <span>Nueva</span>
          </button>
        </div>

        <!-- Selector de tipo de filtro -->
        <div class="filtro-tipo-selector">
          <label class="radio-option">
            <input
              type="radio"
              value="calendario"
              v-model="tipoFiltro"
              @change="cambiarTipoFiltro"
            />
            <span class="radio-label">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Filtrar por Calendario
            </span>
          </label>
          <label class="radio-option">
            <input
              type="radio"
              value="fechas"
              v-model="tipoFiltro"
              @change="cambiarTipoFiltro"
            />
            <span class="radio-label">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
              </svg>
              Filtrar por Fechas
            </span>
          </label>
        </div>

        <!-- Calendario Compacto (solo si tipoFiltro === 'calendario') -->
        <div v-if="tipoFiltro === 'calendario'" class="calendario-compacto">
          <div class="calendario-header">
            <button @click="mesAnterior" class="btn-nav-mes">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <div class="mes-year-selector">
              <div class="mes-actual">{{ nombreMesActual }} {{ calendarioYear }}</div>
              <select v-model="calendarioYear" @change="cambiarYear" class="year-select">
                <option v-for="year in yearsDisponibles" :key="year" :value="year">
                  {{ year }}
                </option>
              </select>
            </div>
            <button @click="mesSiguiente" class="btn-nav-mes">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>

          <!-- Botón para limpiar filtro de día -->
          <div v-if="diaSeleccionado" class="filtro-dia-activo">
            <span class="texto-filtro">Mostrando: {{ formatearFecha(diaSeleccionado) }}</span>
            <button @click="diaSeleccionado = null" class="btn-limpiar-dia">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
              Ver todas
            </button>
          </div>

          <div class="calendario-grid">
            <div class="dia-semana" v-for="dia in diasSemana" :key="dia">{{ dia }}</div>
            <div
              v-for="dia in diasDelMes"
              :key="dia.fecha"
              :class="['dia-mes', {
                'dia-otro-mes': !dia.mesActual,
                'dia-hoy': dia.esHoy,
                'dia-seleccionado': dia.fecha === diaSeleccionado,
                'dia-con-planificaciones': dia.cantidad > 0
              }]"
              @click="seleccionarDia(dia)"
            >
              <span class="numero-dia">{{ dia.numero }}</span>
              <span v-if="dia.cantidad > 0" class="indicador-planificaciones">
                <span class="punto-indicador" :class="{ 'multiple': dia.cantidad > 1 }"></span>
                <span v-if="dia.cantidad > 1" class="numero-planificaciones">{{ dia.cantidad }}</span>
              </span>
            </div>
          </div>

          <!-- Chips de estadísticas dentro del calendario -->
          <div class="stats-chips-container">
            <div
              class="stat-chip stat-chip-generada"
              :class="{ 'stat-chip-active': filtros.estadoSeleccionado === 'Generada' }"
              @click="filtrarPorEstado('Generada')"
            >
              <span class="chip-dot"></span>
              <span class="chip-label">Generadas</span>
              <span class="chip-value">{{ estadisticas.generadas }}</span>
            </div>

            <div
              class="stat-chip stat-chip-registrada"
              :class="{ 'stat-chip-active': filtros.estadoSeleccionado === 'Registrada' }"
              @click="filtrarPorEstado('Registrada')"
            >
              <span class="chip-dot"></span>
              <span class="chip-label">Registradas</span>
              <span class="chip-value">{{ estadisticas.registradas }}</span>
            </div>

            <div
              class="stat-chip stat-chip-eliminado"
              :class="{ 'stat-chip-active': filtros.estadoSeleccionado === 'Eliminado' }"
              @click="filtrarPorEstado('Eliminado')"
            >
              <span class="chip-dot"></span>
              <span class="chip-label">Anuladas</span>
              <span class="chip-value">{{ estadisticas.eliminadas }}</span>
            </div>

            <div
              class="stat-chip stat-chip-norealizada"
              :class="{ 'stat-chip-active': filtros.estadoSeleccionado === 'No Realizada' }"
              @click="filtrarPorEstado('No Realizada')"
            >
              <span class="chip-dot"></span>
              <span class="chip-label">No Realizadas</span>
              <span class="chip-value">{{ estadisticas.noRealizadas }}</span>
            </div>
          </div>
        </div>

        <!-- Filtros de fecha (solo si tipoFiltro === 'fechas') -->
        <div v-if="tipoFiltro === 'fechas'" class="filters-container">
          <div class="filter-group">
            <label class="filter-label">Fecha Inicio</label>
            <input
              type="date"
              v-model="filtros.fechaInicio"
              class="filter-input"
              @change="filtrarActividades"
            />
          </div>

          <div class="filter-group">
            <label class="filter-label">Fecha Fin</label>
            <input
              type="date"
              v-model="filtros.fechaFin"
              class="filter-input"
              @change="filtrarActividades"
            />
          </div>

          <button @click="limpiarFiltros" class="btn-clear-filters">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
            Limpiar
          </button>

          <button @click="cargarActividades" class="btn-reload-filters">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            Recargar
          </button>
        </div>
      </div>
    </div>

    <!-- Tablero de actividades -->
    <div class="activities-board">
      <div v-if="cargando" class="loading-container">
        <div class="spinner"></div>
        <p>Cargando planificaciones...</p>
      </div>

      <div v-else-if="actividadesFiltradas.length === 0" class="empty-state">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        <h3>No hay planificaciones{{ diaSeleccionado ? ' para este día' : '' }}</h3>
        <p v-if="diaSeleccionado">
          No hay planificaciones registradas para el {{ formatearFecha(diaSeleccionado) }}
        </p>
        <p v-else>Agrega tu primera planificación para comenzar</p>
        <button @click="abrirModalAgregar" class="btn-add-first">
          Agregar Planificación
        </button>
      </div>

      <div v-else class="activities-grid">
        <div
          v-for="actividad in actividadesFiltradas"
          :key="actividad.id"
          :class="['activity-card', 'card-' + obtenerClaseEstado(actividad.estado)]"
          @click="verDetalle(actividad)"
        >
          <!-- Badge de estado -->
          <div class="card-header">
            <span :class="['status-badge', 'badge-' + obtenerClaseEstado(actividad.estado)]">
              <span class="badge-dot"></span>
              {{ actividad.estado }}
            </span>
            <div class="dropdown-menu-container">
              <button @click.stop="toggleMenuOpciones(actividad.id)" class="btn-menu">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                </svg>
              </button>
              <transition name="dropdown-fade">
                <div v-if="menuActivo === actividad.id" class="dropdown-menu-list" @click.stop>
                  <button @click.stop="editarDesdeMenu(actividad)" class="dropdown-item dropdown-item-edit">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                    <span>Editar</span>
                  </button>
                  <button v-if="actividad.estadoNumerico == 0" @click.stop="confirmarNoRealizada(actividad)" class="dropdown-item dropdown-item-norealizada">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                    </svg>
                    <span>No Realizada</span>
                  </button>
                  <button v-if="actividad.estadoNumerico == 0" @click.stop="confirmarEliminar(actividad)" class="dropdown-item dropdown-item-delete">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                    <span>Eliminar</span>
                  </button>
                </div>
              </transition>
            </div>
          </div>

          <!-- Contenido de la card -->
          <div class="card-body">
            <h3 class="card-title">{{ actividad.asignado }}</h3>
            <p class="card-description">{{ actividad.titulo || 'Sin descripción' }}</p>
            <p class="card-description1">{{ actividad.descripcion || 'Sin descripción' }}</p>
            <!-- {{ actividad }} -->
            <div class="card-meta">
              <div class="meta-item-inline">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <span>{{ formatearFecha(actividad.fecha) }}</span>
                <span v-if="actividad.hora" class="separator">•</span>
                <svg v-if="actividad.hora" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span v-if="actividad.hora">{{ actividad.hora }}</span>
              </div>
            </div>

            <div class="card-footer">
              <!-- <div class="ubicacion-status"> -->
                <div class="ubicacion-item">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="icon-ubicacion">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <span :class="actividad.latitud ? 'ubicacion-registrada' : 'ubicacion-sin-registrar'">
                    INICIA VISITA: {{ actividad.latitud ? '✓ Registrada' : 'Sin registrar' }}
                  </span>
                </div>
                <div class="ubicacion-item">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="icon-ubicacion">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <span :class="actividad.latitud_fin ? 'ubicacion-registrada' : 'ubicacion-sin-registrar'">
                    FINALIZA VISITA: {{ actividad.latitud_fin ? '✓ Registrada' : 'Sin registrar' }}
                  </span>
                <!-- </div> -->
              </div>
            </div>
          </div>

          <!-- Barra de progreso si tiene -->
          <!-- <div v-if="actividad.progreso !== undefined" class="card-progress">
            <div class="progress-bar">
              <div
                class="progress-fill"
                :style="{ width: actividad.progreso + '%' }"
              ></div>
            </div>
            <span class="progress-text">{{ actividad.progreso }}%</span>
          </div> -->
        </div>
      </div>
    </div>

    <!-- Modal para agregar/editar planificación -->
    <vs-popup class="popup-planificacion" :title="(modoEdicion ? 'Editar' : 'Nueva') + ' Planificación'" :active.sync="modalAbierto" @close="cerrarModal">
      <div class="popup-body-planificacion">
          <!-- Sección de Institución -->
          <div class="form-group institucion-section">
            <label class="opciones-titulo">Institución</label>
            <p class="opciones-subtitulo">Seleccione la institución para la planificación</p>

            <div v-if="!institucionSeleccionada" class="institucion-search">
              <div class="inst-tipo-selector">
                <vs-button
                  @click="tipoInstitucion = 'normal'"
                  :color="tipoInstitucion === 'normal' ? 'primary' : 'dark'"
                  :type="tipoInstitucion === 'normal' ? 'filled' : 'flat'"
                  icon-pack="feather"
                  icon="icon-search"
                  size="small"
                  class="inst-tipo-btn"
                >Registradas</vs-button>
                <vs-button
                  @click="tipoInstitucion = 'temporal'"
                  :color="tipoInstitucion === 'temporal' ? 'primary' : 'dark'"
                  :type="tipoInstitucion === 'temporal' ? 'filled' : 'flat'"
                  icon-pack="feather"
                  icon="icon-plus-circle"
                  size="small"
                  class="inst-tipo-btn"
                >Temporales</vs-button>
              </div>

              <div v-if="tipoInstitucion === 'normal'" class="search-box">
                <vs-input
                  v-model="busquedaInstitucion"
                  placeholder="Buscar institución (mín. 5 caracteres)..."
                  class="w-full"
                  icon-pack="feather"
                  icon="icon-search"
                  @keyup.enter.native="buscarInstituciones"
                />
                <vs-button @click="buscarInstituciones" color="primary" type="filled" icon-pack="feather" icon="icon-search" class="btn-buscar-inst">Buscar</vs-button>
              </div>

              <div v-if="tipoInstitucion === 'temporal'" class="temporal-actions">
                <vs-button @click="abrirModalInstitucionTemporal" color="success" type="border" icon-pack="feather" icon="icon-plus" class="w-full">Nueva Institución Temporal</vs-button>
                <vs-button @click="cargarInstitucionesTemporales" color="primary" type="border" icon-pack="feather" icon="icon-refresh-cw" class="w-full">Cargar Mis Instituciones</vs-button>
              </div>

              <!-- Resultados de búsqueda -->
              <div v-if="instituciones.length > 0" class="instituciones-list">
                <div class="list-header">
                  <span>{{ instituciones.length }} instituciones encontradas</span>
                </div>
                <div
                  v-for="inst in instituciones"
                  :key="inst.id"
                  @click="seleccionarInstitucion(inst)"
                  class="institucion-item"
                >
                  <div class="inst-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                  </div>
                  <div class="inst-info">
                    <div class="inst-nombre">{{ inst.nombre }}</div>
                    <div class="inst-detalle">{{ inst.ciudad || 'Sin ciudad' }}</div>
                     <div class="inst-detalle">Asesor: {{ inst.nombre_asesor || 'Sin asesor' }}</div>
                  </div>
                  <div class="inst-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <!-- Institución seleccionada -->
            <div v-else class="institucion-selected">
              <div class="selected-card">
                <div class="selected-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div class="selected-info">
                  <div class="selected-label">Institución Seleccionada</div>
                  <div class="selected-name">{{ formulario.nombre_institucion }}</div>
                  <div class="selected-type">{{ formulario.estado_institucion_temporal === 1 ? 'Temporal' : 'Registrada' }}</div>
                </div>
                <button @click="limpiarInstitucion" class="btn-remove-inst" type="button">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label>Título</label>
            <input
              type="text"
              v-model="formulario.titulo"
              placeholder="Ingrese el título"
              class="form-input"
            />
          </div>

          <div class="form-group">
            <label>Descripción</label>
            <textarea
              v-model="formulario.descripcion"
              placeholder="Ingrese una descripción"
              class="form-textarea"
              rows="3"
            ></textarea>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Fecha</label>
              <input
                type="date"
                v-model="formulario.fecha"
                class="form-input"
              />
            </div>

            <div class="form-group">
              <label>Hora</label>
              <input
                type="time"
                v-model="formulario.hora"
                class="form-input"
              />
            </div>
          </div>

          <div class="form-group">
            <label class="opciones-titulo">Opciones de Actividad</label>
            <p class="opciones-subtitulo">Selecciona al menos una opción</p>
            <div class="opciones-grid">
              <label class="checkbox-label">
                <input type="checkbox" v-model="opciones.presentacion" />
                <span>Presentación</span>
              </label>
              <label class="checkbox-label">
                <input type="checkbox" v-model="opciones.entrega_muestras" />
                <span>Entrega de Muestras</span>
              </label>
              <label class="checkbox-label">
                <input type="checkbox" v-model="opciones.reunion" />
                <span>Reunión</span>
              </label>
              <label class="checkbox-label">
                <input type="checkbox" v-model="opciones.seguimiento" />
                <span>Seguimiento</span>
              </label>
              <label class="checkbox-label">
                <input type="checkbox" v-model="opciones.cierre" />
                <span>Cierre</span>
              </label>
              <label class="checkbox-label">
                <input type="checkbox" v-model="opciones.cobranza" />
                <span>Cobranza</span>
              </label>
              <label class="checkbox-label">
                <input type="checkbox" v-model="opciones.post_venta" />
                <span>Post Venta</span>
              </label>
              <label class="checkbox-label">
                <input type="checkbox" v-model="opciones.retiro_cartas" />
                <span>Retiro de Cartas</span>
              </label>
              <label class="checkbox-label">
                <input type="checkbox" v-model="opciones.retiro_muestras" />
                <span>Retiro de Muestras</span>
              </label>
              <label class="checkbox-label">
                <input type="checkbox" v-model="opciones.capacitacion" />
                <span>Capacitación</span>
              </label>
              <label class="checkbox-label checkbox-editorial">
                <input type="checkbox" v-model="opciones.otraEditorial" @change="onCambioOtraEditorial" />
                <span>Otra Editorial</span>
              </label>
            </div>
            <div v-if="opciones.otraEditorial" class="editorial-input-container">
              <label class="form-label-editorial">Nombre de la Editorial <span class="required">*</span></label>
              <input
                type="text"
                v-model="opciones.editorial"
                class="form-input"
                placeholder="Escriba el nombre de la editorial"
              />
            </div>
          </div>

          <div v-if="modoEdicion" class="form-group ubicacion-section">
            <label class="opciones-titulo">Registro de Ubicación</label>
            <p class="opciones-subtitulo">Registra tu ubicación durante la actividad</p>

            <div class="ubicacion-buttons">
              <button
                @click="registrarUbicacionInicio"
                class="btn-ubicacion"
                :class="formulario.latitud ? 'btn-ubicacion-registrado' : 'btn-ubicacion-pendiente'"
                :disabled="formulario.latitud"
                type="button"
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span v-if="!formulario.latitud">INICIAR VISITA</span>
                <span v-else>✓ Ubicación de Inicio Registrada</span>
              </button>

              <button
                v-if="formulario.latitud"
                @click="registrarUbicacionFin"
                class="btn-ubicacion"
                :class="formulario.latitud_fin ? 'btn-ubicacion-registrado' : 'btn-ubicacion-pendiente'"
                :disabled="formulario.latitud_fin"
                type="button"
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                </svg>
                <span v-if="!formulario.latitud_fin">FINALIZAR VISITA</span>
                <span v-else>✓ Ubicación Final Registrada</span>
              </button>
            </div>

            <div v-if="formulario.latitud" class="ubicacion-info">
              <!-- Mapa de Ubicación Inicio -->
              <div class="mapa-ubicacion-container">
                <div class="mapa-header">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="mapa-icon">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <div>
                    <strong>Ubicación Inicio</strong>
                    <small>{{ formulario.latitud }}, {{ formulario.longitud }}</small>
                    <small class="fecha-captura" v-if="formulario.fecha_captura_longitud">{{ formatearFechaHora(formulario.fecha_captura_longitud) }}</small>
                  </div>
                </div>
                <div class="mapa-embed">
                  <iframe
                    :src="`https://maps.google.com/maps?q=${formulario.latitud},${formulario.longitud}&z=16&output=embed`"
                    width="100%"
                    height="100%"
                    frameborder="0"
                    style="border:0;"
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
                <div class="mapa-actions">
                  <button type="button" class="btn-ver-mapa" @click="verEnGoogleMaps(formulario.latitud, formulario.longitud)">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                    Ver en Google Maps
                  </button>
                </div>
              </div>

              <!-- Mapa de Ubicación Fin -->
              <div v-if="formulario.latitud_fin" class="mapa-ubicacion-container mapa-fin">
                <div class="mapa-header">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="mapa-icon">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                  </svg>
                  <div>
                    <strong>Ubicación Fin</strong>
                    <small>{{ formulario.latitud_fin }}, {{ formulario.longitud_fin }}</small>
                    <small class="fecha-captura" v-if="formulario.fecha_captura_longitud_fin">{{ formatearFechaHora(formulario.fecha_captura_longitud_fin) }}</small>
                  </div>
                </div>
                <div class="mapa-embed">
                  <iframe
                    :src="`https://maps.google.com/maps?q=${formulario.latitud_fin},${formulario.longitud_fin}&z=16&output=embed`"
                    width="100%"
                    height="100%"
                    frameborder="0"
                    style="border:0;"
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
                <div class="mapa-actions">
                  <button type="button" class="btn-ver-mapa" @click="verEnGoogleMaps(formulario.latitud_fin, formulario.longitud_fin)">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                    Ver en Google Maps
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="popup-footer-planificacion">
            <vs-button @click="guardarPlanificacion" color="success" type="gradient">
              {{ modoEdicion ? 'Actualizar' : 'Guardar' }}
            </vs-button>
            <vs-button @click="cerrarModal" color="danger" type="border">Cancelar</vs-button>
          </div>
      </div>
    </vs-popup>

    <!-- Modal para crear institución temporal -->
    <vs-popup class="popup-temporal" title="Nueva Institución Temporal" :active.sync="mostrarFormularioTemporal">
      <div class="popup-body-temporal">
          <div class="form-group">
            <label>Nombre de la Institución *</label>
            <input
              type="text"
              v-model="institucionTemporal.nombre"
              placeholder="Ingrese el nombre de la institución"
              class="form-input"
            />
          </div>

          <div class="form-group">
            <label>Región *</label>
            <select v-model="institucionTemporal.region" @change="cargarPeriodos" class="form-select">
              <option value="1">Sierra</option>
              <option value="2">Costa</option>
            </select>
          </div>

          <div class="form-group">
            <label>Ciudad *</label>
            <select v-model="institucionTemporal.ciudad" class="form-select">
              <option :value="null">Seleccione una ciudad</option>
              <option v-for="ciudad in arregloCiudades" :key="ciudad.idciudad" :value="ciudad">
                {{ ciudad.nombre }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Período *</label>
            <select v-model="institucionTemporal.periodo" class="form-select">
              <option :value="null">Seleccione un período</option>
              <option v-for="periodo in arregloPeriodos" :key="periodo.id" :value="periodo.id">
                {{ periodo.nombre }}
              </option>
            </select>
            <p class="form-help">Primero seleccione la región para cargar los períodos</p>
          </div>

          <div class="popup-footer-planificacion">
            <vs-button @click="mostrarFormularioTemporal = false" color="danger" type="border">Cancelar</vs-button>
            <vs-button @click="crearInstitucionTemporal" color="success" type="gradient">
              Guardar Institución
            </vs-button>
          </div>
      </div>
    </vs-popup>

    <!-- Modal de confirmación de eliminación -->
    <vs-popup class="popup-confirm-delete" title="Confirmar Eliminación" :active.sync="popupConfirmDelete">
      <div class="confirm-delete-body">
        <div class="confirm-delete-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>
        <h3>¿Está seguro?</h3>
        <p>Esta acción eliminará la planificación <strong>"{{ actividadAEliminar ? actividadAEliminar.titulo : '' }}"</strong>. Esta acción no se puede deshacer.</p>
        <div class="confirm-delete-actions">
          <vs-button color="danger" @click="ejecutarEliminar" type="filled" icon-pack="feather" icon="icon-trash-2">
            Sí, eliminar
          </vs-button>
          <vs-button color="dark" type="border" @click="popupConfirmDelete = false" icon-pack="feather" icon="icon-x">
            Cancelar
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- Modal de confirmación No Realizada -->
    <vs-popup class="popup-confirm-delete" title="Marcar como No Realizada" :active.sync="popupConfirmNoRealizada">
      <div class="confirm-delete-body">
        <div class="confirm-delete-icon confirm-norealizada-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
          </svg>
        </div>
        <h3>¿Marcar como No Realizada?</h3>
        <p>La planificación <strong>"{{ actividadNoRealizada ? actividadNoRealizada.titulo : '' }}"</strong> será marcada como no realizada.</p>
        <div class="confirm-delete-actions">
          <vs-button color="warning" @click="ejecutarNoRealizada" type="filled" icon-pack="feather" icon="icon-slash">
            Sí, marcar
          </vs-button>
          <vs-button color="dark" type="border" @click="popupConfirmNoRealizada = false" icon-pack="feather" icon="icon-x">
            Cancelar
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: 'PlanificacionesAgendaListado',
  props: {
    usuarioExterno: {
      type: Object,
      default: null
    }
  },
  data() {
    const hoy = new Date()
    const primerDiaMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1)
    const formatFecha = (date) => {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return year + '-' + month + '-' + day
    }

    return {
      cargando: false,
      modalAbierto: false,
      modoEdicion: false,
      usuario: null,
      tipoFiltro: 'calendario', // 'calendario' o 'fechas'
      filtros: {
        fechaInicio: formatFecha(primerDiaMes),
        fechaFin: formatFecha(hoy),
        estadoSeleccionado: null // null = todos, 'Generada', 'Registrada', 'Eliminado', 'No Realizada'
      },
      formulario: {
        id: null,
        titulo: '',
        descripcion: '',
        fecha: '',
        hora: '',
        estado: 'Pendiente',
        asignado: '',
        progreso: 0,
        latitud: null,
        longitud: null,
        fecha_captura_longitud: null,
        latitud_fin: null,
        longitud_fin: null,
        fecha_captura_longitud_fin: null,
        institucion_id: null,
        institucion_id_temporal: null,
        estado_institucion_temporal: 0,
        periodo_id: null,
        nombre_institucion: ''
      },
      tipoInstitucion: 'normal',
      tabInstitucion: 0,
      busquedaInstitucion: '',
      instituciones: [],
      institucionSeleccionada: false,
      mostrarFormularioTemporal: false,
      institucionTemporal: {
        nombre: '',
        ciudad: null,
        region: '2',
        periodo: null
      },
      arregloCiudades: [],
      arregloPeriodos: [],
      opciones: {
        presentacion: false,
        entrega_muestras: false,
        reunion: false,
        seguimiento: false,
        cierre: false,
        cobranza: false,
        post_venta: false,
        retiro_cartas: false,
        retiro_muestras: false,
        capacitacion: false,
        otraEditorial: false,
        editorial: ''
      },
      actividades: [],
      menuActivo: null,
      popupConfirmDelete: false,
      actividadAEliminar: null,
      popupConfirmNoRealizada: false,
      actividadNoRealizada: null,
      // Datos del calendario
      calendarioYear: new Date().getFullYear(),
      calendarioMonth: new Date().getMonth() + 1,
      calendarioDatos: {}, // { "2026-03-01": 2, "2026-03-02": 1 }
      calendarioYearCargado: null, // Para trackear qué año ya se cargó
      diaSeleccionado: null,
      diasSemana: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
      mostrarEstadisticas: false // Por defecto ocultas en móvil
    }
  },
  computed: {
    actividadesFiltradas() {
      let resultado = [...this.actividades]

      // Filtrar según el tipo de filtro seleccionado
      if (this.tipoFiltro === 'calendario') {
        // Si hay un día seleccionado del calendario, filtrar por ese día
        if (this.diaSeleccionado) {
          resultado = resultado.filter(act => act.fecha === this.diaSeleccionado)
        }
        // Si no hay día seleccionado, mostrar todas las del mes actual del calendario
        else {
          const year = this.calendarioYear
          const month = String(this.calendarioMonth).padStart(2, '0')
          resultado = resultado.filter(act => {
            return act.fecha && act.fecha.startsWith(`${year}-${month}`)
          })
        }
      } else {
        // Filtros por rango de fechas
        if (this.filtros.fechaInicio) {
          resultado = resultado.filter(act => act.fecha >= this.filtros.fechaInicio)
        }

        if (this.filtros.fechaFin) {
          resultado = resultado.filter(act => act.fecha <= this.filtros.fechaFin)
        }
      }

      // Filtrar por estado seleccionado (aplica a ambos tipos de filtro)
      if (this.filtros.estadoSeleccionado) {
        resultado = resultado.filter(act => act.estado === this.filtros.estadoSeleccionado)
      }

      return resultado.sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
    },
    estadisticas() {
      // Calcular estadísticas según el tipo de filtro
      let actividadesPorFecha = [...this.actividades]

      if (this.tipoFiltro === 'calendario') {
        // Si hay un día seleccionado, mostrar estadísticas solo de ese día
        if (this.diaSeleccionado) {
          actividadesPorFecha = actividadesPorFecha.filter(act => act.fecha === this.diaSeleccionado)
        } else {
          // Si no hay día seleccionado, filtrar por el mes actual del calendario
          const year = this.calendarioYear
          const month = String(this.calendarioMonth).padStart(2, '0')
          actividadesPorFecha = actividadesPorFecha.filter(act => {
            return act.fecha && act.fecha.startsWith(`${year}-${month}`)
          })
        }
      } else {
        // Filtrar por rango de fechas
        if (this.filtros.fechaInicio) {
          actividadesPorFecha = actividadesPorFecha.filter(act => act.fecha >= this.filtros.fechaInicio)
        }

        if (this.filtros.fechaFin) {
          actividadesPorFecha = actividadesPorFecha.filter(act => act.fecha <= this.filtros.fechaFin)
        }
      }

      return {
        generadas: actividadesPorFecha.filter(a => a.estado === 'Generada').length,
        registradas: actividadesPorFecha.filter(a => a.estado === 'Registrada').length,
        eliminadas: actividadesPorFecha.filter(a => a.estado === 'Eliminado').length,
        noRealizadas: actividadesPorFecha.filter(a => a.estado === 'No Realizada').length
      }
    },
    nombreMesActual() {
      const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                     'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
      return meses[this.calendarioMonth - 1]
    },
    yearsDisponibles() {
      // Generar años desde 2020 hasta 3 años en el futuro
      const yearActual = new Date().getFullYear()
      const years = []
      for (let year = 2020; year <= yearActual + 3; year++) {
        years.push(year)
      }
      return years
    },
    diasDelMes() {
      const year = this.calendarioYear
      const month = this.calendarioMonth
      const primerDia = new Date(year, month - 1, 1)
      const ultimoDia = new Date(year, month, 0)
      const diasEnMes = ultimoDia.getDate()
      const primerDiaSemana = primerDia.getDay()

      const hoy = new Date()
      const hoyStr = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-${String(hoy.getDate()).padStart(2, '0')}`

      let dias = []

      // Días del mes anterior para completar la primera semana
      const mesAnterior = month === 1 ? 12 : month - 1
      const yearAnterior = month === 1 ? year - 1 : year
      const ultimoDiaMesAnterior = new Date(yearAnterior, mesAnterior, 0).getDate()

      for (let i = primerDiaSemana - 1; i >= 0; i--) {
        const dia = ultimoDiaMesAnterior - i
        const fecha = `${yearAnterior}-${String(mesAnterior).padStart(2, '0')}-${String(dia).padStart(2, '0')}`
        dias.push({
          numero: dia,
          fecha: fecha,
          mesActual: false,
          esHoy: false,
          cantidad: 0
        })
      }

      // Días del mes actual
      for (let dia = 1; dia <= diasEnMes; dia++) {
        const fecha = `${year}-${String(month).padStart(2, '0')}-${String(dia).padStart(2, '0')}`
        dias.push({
          numero: dia,
          fecha: fecha,
          mesActual: true,
          esHoy: fecha === hoyStr,
          cantidad: this.calendarioDatos[fecha] || 0
        })
      }

      // Días del mes siguiente para completar la última semana
      const diasRestantes = 42 - dias.length // 6 semanas * 7 días
      const mesSiguiente = month === 12 ? 1 : month + 1
      const yearSiguiente = month === 12 ? year + 1 : year

      for (let dia = 1; dia <= diasRestantes; dia++) {
        const fecha = `${yearSiguiente}-${String(mesSiguiente).padStart(2, '0')}-${String(dia).padStart(2, '0')}`
        dias.push({
          numero: dia,
          fecha: fecha,
          mesActual: false,
          esHoy: false,
          cantidad: 0
        })
      }

      return dias
    }
  },
  methods: {
    determinarUsuario() {
      let me = this

      // Si viene usuarioExterno desde el prop (login independiente)
      if (me.usuarioExterno) {
        me.usuario = {
          idusuario: me.usuarioExterno.idusuario,
          cedula: me.usuarioExterno.cedula,
          nombre: me.usuarioExterno.nombres || me.usuarioExterno.name_usuario,
          apellido: me.usuarioExterno.apellidos
        }
        console.log('Usuario cargado desde login independiente:', me.usuario)
        return
      }

      // Si está en la ruta /asesor/planificaciones (acceso directo)
      if (this.$route.path === '/asesor/planificaciones') {
        const userPlanificaciones = localStorage.getItem('userPlanificaciones')
        if (userPlanificaciones) {
          try {
            const user = JSON.parse(userPlanificaciones)
            me.usuario = {
              idusuario: user.idusuario,
              cedula: user.cedula,
              nombre: user.nombres || user.name_usuario,
              apellido: user.apellidos
            }
            console.log('Usuario cargado desde userPlanificaciones:', me.usuario)
            return
          } catch (error) {
            console.error('Error al parsear userPlanificaciones:', error)
          }
        }
      }

      // Si no hay usuario externo ni userPlanificaciones, usar el usuario normal de la plataforma
      const usuarioPlataforma = localStorage.getItem('usuario')
      if (usuarioPlataforma) {
        try {
          me.usuario = JSON.parse(usuarioPlataforma)
          console.log('Usuario cargado desde plataforma:', me.usuario)
        } catch (error) {
          console.error('Error al parsear usuario de plataforma:', error)
        }
      }

      // Si no hay ningún usuario, mostrar error
      if (!me.usuario) {
        me.$vs.notify({
          title: 'Error',
          text: 'No se pudo cargar la información del usuario',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      }
    },
   async cargarActividades() {
  let me = this
  me.cargando = true
  me.$vs.loading()
  try {
    // Obtener el mes y año actual del calendario
    const mes = me.calendarioMonth
    const anio = me.calendarioYear

    // Construir URL con filtros de mes y año
    const url = `${me.$server_url}agenda-planificacion?usuario_id=${me.usuario.idusuario}&mes=${mes}&anio=${anio}`

    const response = await me.$http.get(url)

    if (response.data.success) {
      me.actividades = response.data.data.map(item => {
        const opciones = JSON.parse(item.opciones || '{}')

        // Extraer solo la fecha (YYYY-MM-DD) del startDate
        let fechaSolo = ''
        if (item.startDate) {
          // Si viene en formato ISO: 2026-03-04T05:00:00.000000Z
          if (item.startDate.includes('T')) {
            fechaSolo = item.startDate.split('T')[0]
          } else {
            // Si viene en formato SQL: 2026-03-04 08:42:30
            fechaSolo = item.startDate.substring(0, 10)
          }
        }

        return {
          id: item.id,
          titulo: item.title,
          descripcion: item.url,
          fecha: fechaSolo,
          hora: item.hora_inicio,
          estado: me.obtenerEstadoTexto(item.estado),
          asignado: item.nombre_institucion || item.nombre_institucion_temporal || 'Sin institución',
          progreso: me.calcularProgreso(item.estado),
          estadoNumerico: item.estado,
          opciones: opciones,
          latitud: item.latitud,
          longitud: item.longitud,
          fecha_captura_longitud: item.fecha_captura_longitud,
          latitud_fin: item.latitud_fin,
          longitud_fin: item.longitud_fin,
          fecha_captura_longitud_fin: item.fecha_captura_longitud_fin,
          datosCompletos: item
        }
      })

      // Forzar recarga del calendario
      me.calendarioYearCargado = null
      await me.cargarCalendario()
    }
  } catch (error) {
    console.error('Error cargando actividades:', error)
    me.$vs.notify({
      title: 'Error',
      text: 'Error al cargar las planificaciones',
      color: 'danger',
      iconPack: 'feather',
      icon: 'icon-alert-circle'
    })
  } finally {
    me.cargando = false
    me.$vs.loading.close()
  }
},
    filtrarActividades() {
      // El computed ya maneja el filtrado
      // Actualizar el calendario según el rango de fechas
      if (this.filtros.fechaInicio) {
        const fecha = new Date(this.filtros.fechaInicio + 'T00:00:00')
        this.calendarioYear = fecha.getFullYear()
        this.calendarioMonth = fecha.getMonth() + 1
        this.diaSeleccionado = null
        this.cargarCalendario()
      }
    },
    cambiarTipoFiltro() {
      // Limpiar selecciones al cambiar de tipo de filtro
      this.diaSeleccionado = null
      this.filtros.estadoSeleccionado = null

      if (this.tipoFiltro === 'calendario') {
        // Al cambiar a calendario, volver al mes actual
        const hoy = new Date()
        this.calendarioYear = hoy.getFullYear()
        this.calendarioMonth = hoy.getMonth() + 1
        this.cargarCalendario()
      }
    },
    limpiarFiltros() {
      const hoy = new Date()
      const primerDiaMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1)
      const formatFecha = (date) => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return year + '-' + month + '-' + day
      }

      this.filtros.fechaInicio = formatFecha(primerDiaMes)
      this.filtros.fechaFin = formatFecha(hoy)
      this.filtros.estadoSeleccionado = null
      this.diaSeleccionado = null

      // Volver al mes actual
      this.calendarioYear = hoy.getFullYear()
      this.calendarioMonth = hoy.getMonth() + 1
      this.cargarCalendario()
    },
    filtrarPorEstado(estado) {
      // Si ya está seleccionado el mismo estado, lo deselecciona (muestra todos)
      if (this.filtros.estadoSeleccionado === estado) {
        this.filtros.estadoSeleccionado = null
      } else {
        this.filtros.estadoSeleccionado = estado
      }
    },
    abrirModalAgregar() {
      this.modoEdicion = false
      this.limpiarFormulario()

      // Si hay un día seleccionado en el calendario, usar esa fecha
      if (this.diaSeleccionado) {
        this.formulario.fecha = this.diaSeleccionado
      } else {
        // Sino, usar la fecha actual
        const ahora = new Date()
        const yyyy = ahora.getFullYear()
        const mm = String(ahora.getMonth() + 1).padStart(2, '0')
        const dd = String(ahora.getDate()).padStart(2, '0')
        this.formulario.fecha = `${yyyy}-${mm}-${dd}`
      }

      // Siempre usar la hora actual
      const ahora = new Date()
      const hh = String(ahora.getHours()).padStart(2, '0')
      const mi = String(ahora.getMinutes()).padStart(2, '0')
      this.formulario.hora = `${hh}:${mi}`

      this.modalAbierto = true
    },
    verDetalle(actividad) {
      let me = this
      me.modoEdicion = true
      me.formulario = { ...actividad }

      if (actividad.opciones) {
        me.opciones = { ...actividad.opciones }
      }

      // Cargar el nombre de la editorial desde datosCompletos.otraEditorial
      if (actividad.datosCompletos && actividad.datosCompletos.otraEditorial) {
        me.opciones.editorial = actividad.datosCompletos.otraEditorial
        // Si hay un nombre de editorial, marcar el checkbox como true
        if (me.opciones.editorial && me.opciones.editorial.trim() !== '') {
          me.opciones.otraEditorial = true
        }
      }

      if (actividad.datosCompletos) {
        me.formulario.institucion_id = actividad.datosCompletos.institucion_id
        me.formulario.institucion_id_temporal = actividad.datosCompletos.institucion_id_temporal
        me.formulario.estado_institucion_temporal = actividad.datosCompletos.estado_institucion_temporal
        me.formulario.periodo_id = actividad.datosCompletos.periodo_id
        me.formulario.nombre_institucion = actividad.datosCompletos.nombre_institucion_temporal || actividad.asignado

        if (me.formulario.institucion_id || me.formulario.institucion_id_temporal) {
          me.institucionSeleccionada = true
        }
      }

      me.modalAbierto = true
    },
    cerrarModal() {
      this.modalAbierto = false
      this.limpiarFormulario()
    },
    limpiarFormulario() {
      this.formulario = {
        id: null,
        titulo: '',
        descripcion: '',
        fecha: '',
        hora: '',
        estado: 'Pendiente',
        asignado: '',
        progreso: 0,
        latitud: null,
        longitud: null,
        fecha_captura_longitud: null,
        latitud_fin: null,
        longitud_fin: null,
        fecha_captura_longitud_fin: null,
        institucion_id: null,
        institucion_id_temporal: null,
        estado_institucion_temporal: 0,
        periodo_id: null,
        nombre_institucion: ''
      }
      this.opciones = {
        presentacion: false,
        entrega_muestras: false,
        reunion: false,
        seguimiento: false,
        cierre: false,
        cobranza: false,
        post_venta: false,
        retiro_cartas: false,
        retiro_muestras: false,
        capacitacion: false,
        otraEditorial: false,
        editorial: ''
      }
      this.institucionSeleccionada = false
      this.instituciones = []
      this.busquedaInstitucion = ''
      this.tipoInstitucion = 'normal'
      this.tabInstitucion = 0
      this.mostrarFormularioTemporal = false
    },
    async guardarPlanificacion() {
      let me = this

      if (!me.formulario.institucion_id && !me.formulario.institucion_id_temporal) {
        me.$vs.notify({
          title: 'Validación',
          text: 'Debe seleccionar una institución',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        })
        return
      }

      if (!me.formulario.titulo || me.formulario.titulo.trim() === '') {
        me.$vs.notify({
          title: 'Validación',
          text: 'El título es obligatorio',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        })
        return
      }

      if (!me.formulario.fecha || !me.formulario.hora) {
        me.$vs.notify({
          title: 'Validación',
          text: 'La fecha y hora son obligatorias',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        })
        return
      }

      const opcionesSeleccionadas = Object.entries(me.opciones).some(([key, val]) => key !== 'editorial' && val === true)
      if (!opcionesSeleccionadas) {
        me.$vs.notify({
          title: 'Validación',
          text: 'Debe seleccionar al menos una opción',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        })
        return
      }

      // Validar que si otraEditorial está marcada, el nombre de la editorial no esté vacío
      if (me.opciones.otraEditorial && (!me.opciones.editorial || me.opciones.editorial.trim() === '')) {
        me.$vs.notify({
          title: 'Editorial requerida',
          text: 'Debe escribir el nombre de la editorial',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        })
        return
      }

      me.$vs.loading({ text: 'Guardando planificación...' })

      try {
        // Crear copia de opciones SIN el nombre de la editorial
        const opcionesSinEditorial = { ...me.opciones }
        delete opcionesSinEditorial.editorial
        const opcionesJSON = JSON.stringify(opcionesSinEditorial)
        let formData = new FormData()

        if (me.modoEdicion) {
          formData.append('title', me.formulario.titulo)
          formData.append('startDate', me.formulario.fecha)
          formData.append('hora_inicio', me.formulario.hora)
          formData.append('hora_fin', me.formulario.hora)
          formData.append('opciones', opcionesJSON)
          formData.append('url', me.formulario.descripcion || '')
          formData.append('usuario_editor', me.usuario.idusuario)
          formData.append('endDate', me.formulario.fecha)
          formData.append('estado', me.obtenerEstadoNumerico(me.formulario.estado))

          if (me.formulario.institucion_id) {
            formData.append('institucion_id', me.formulario.institucion_id)
          }
          if (me.formulario.institucion_id_temporal) {
            formData.append('institucion_id_temporal', me.formulario.institucion_id_temporal)
            formData.append('nombre_institucion_temporal', me.formulario.nombre_institucion)
          }
          if (me.formulario.periodo_id) {
            formData.append('periodo_id', me.formulario.periodo_id)
          }
          formData.append('estado_institucion_temporal', me.formulario.estado_institucion_temporal)

          // Guardar el nombre de la editorial en el campo separado
          formData.append('nombre_editorial', me.opciones.editorial || '')

          if (me.formulario.latitud) {
            formData.append('latitud', me.formulario.latitud)
            formData.append('longitud', me.formulario.longitud)
            formData.append('fecha_captura_longitud', me.formulario.fecha_captura_longitud)
          }
          if (me.formulario.latitud_fin) {
            formData.append('latitud_fin', me.formulario.latitud_fin)
            formData.append('longitud_fin', me.formulario.longitud_fin)
            formData.append('fecha_captura_longitud_fin', me.formulario.fecha_captura_longitud_fin)
          }

          formData.append('_method', 'PUT')

          const response = await me.$http.post(
            me.$server_url + 'agenda-planificacion/' + me.formulario.id,
            formData
          )

          if (response.data.success) {
            me.$vs.notify({
              title: 'Éxito',
              text: 'Planificación actualizada exitosamente',
              color: 'success',
              iconPack: 'feather',
              icon: 'icon-check'
            })
            me.cerrarModal()
            me.cargarActividades()
          }
        } else {
          formData.append('title', me.formulario.titulo)
          formData.append('startDate', me.formulario.fecha)
          formData.append('hora_inicio', me.formulario.hora)
          formData.append('hora_fin', me.formulario.hora)
          formData.append('usuario_creador', me.usuario.idusuario)
          formData.append('opciones', opcionesJSON)
          formData.append('url', me.formulario.descripcion || '')
          formData.append('endDate', me.formulario.fecha)
          formData.append('fecha_que_visita', me.formulario.fecha)

          if (me.formulario.institucion_id) {
            formData.append('institucion_id', me.formulario.institucion_id)
          }
          if (me.formulario.institucion_id_temporal) {
            formData.append('institucion_id_temporal', me.formulario.institucion_id_temporal)
            formData.append('nombre_institucion_temporal', me.formulario.nombre_institucion)
          }
          if (me.formulario.periodo_id) {
            formData.append('periodo_id', me.formulario.periodo_id)
          }
          formData.append('estado_institucion_temporal', me.formulario.estado_institucion_temporal)

          // Guardar el nombre de la editorial en el campo separado
          formData.append('nombre_editorial', me.opciones.editorial || '')

          const response = await me.$http.post(
            me.$server_url + 'agenda-planificacion',
            formData
          )

          if (response.data.success) {
            me.$vs.notify({
              title: 'Éxito',
              text: 'Planificación creada exitosamente',
              color: 'success',
              iconPack: 'feather',
              icon: 'icon-check'
            })
            me.cerrarModal()
            me.cargarActividades()
          }
        }
      } catch (error) {
        console.error('Error guardando planificación:', error)
        me.$vs.notify({
          title: 'Error',
          text: error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Error al guardar la planificación',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      } finally {
        me.$vs.loading.close()
      }
    },
    toggleMenuOpciones(actividadId) {
      if (this.menuActivo === actividadId) {
        this.menuActivo = null
      } else {
        this.menuActivo = actividadId
      }
    },
    cerrarMenuOpciones() {
      this.menuActivo = null
    },
    editarDesdeMenu(actividad) {
      this.menuActivo = null
      this.verDetalle(actividad)
    },
    confirmarEliminar(actividad) {
      this.menuActivo = null
      // Solo se puede eliminar si está en estado Generada (0)
      if (actividad.estadoNumerico != 0) {
        let razon = ''
        if (actividad.estadoNumerico == 1) razon = 'está registrada (finalizada)'
        else if (actividad.estadoNumerico == 2) razon = 'ya está eliminada'
        else if (actividad.estadoNumerico == 3) razon = 'está marcada como No Realizada'
        this.$vs.notify({
          title: 'No se puede eliminar',
          text: 'Esta planificación no puede eliminarse porque ' + razon,
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        })
        return
      }
      this.actividadAEliminar = actividad
      this.popupConfirmDelete = true
    },
    async ejecutarEliminar() {
      let me = this
      if (!me.actividadAEliminar) return

      me.popupConfirmDelete = false
      me.$vs.loading({ text: 'Eliminando planificación...' })

      try {
        const response = await me.$http.delete(
          me.$server_url + 'agenda-planificacion/' + me.actividadAEliminar.id
        )

        if (response.data.success) {
          me.$vs.notify({
            title: 'Éxito',
            text: 'Planificación eliminada exitosamente',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check'
          })
          me.cargarActividades()
        } else {
          me.$vs.notify({
            title: 'Error',
            text: response.data.message || 'Error al eliminar la planificación',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        }
      } catch (error) {
        console.error('Error:', error)
        const msg = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Error al eliminar la planificación'
        me.$vs.notify({
          title: 'Error',
          text: msg,
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      } finally {
        me.$vs.loading.close()
        me.actividadAEliminar = null
      }
    },
    confirmarNoRealizada(actividad) {
      this.menuActivo = null
      this.actividadNoRealizada = actividad
      this.popupConfirmNoRealizada = true
    },
    async ejecutarNoRealizada() {
      let me = this
      if (!me.actividadNoRealizada) return

      me.popupConfirmNoRealizada = false
      me.$vs.loading({ text: 'Actualizando planificación...' })

      try {
        const response = await me.$http.post(
          me.$server_url + 'agenda-planificacion/' + me.actividadNoRealizada.id + '/cambiar-estado',
          { estado: 3 }
        )

        if (response.data.success) {
          me.$vs.notify({
            title: 'Éxito',
            text: 'Planificación marcada como No Realizada',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check'
          })
          me.cargarActividades()
        }
      } catch (error) {
        console.error('Error:', error)
        me.$vs.notify({
          title: 'Error',
          text: 'Error al actualizar la planificación',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      } finally {
        me.$vs.loading.close()
        me.actividadNoRealizada = null
      }
    },
    onCambioOtraEditorial() {
      if (!this.opciones.otraEditorial) {
        this.opciones.editorial = ''
      }
    },
    async buscarInstituciones() {
      let me = this

      if (me.busquedaInstitucion.length < 5) {
        me.$vs.notify({
          title: 'Validación',
          text: 'Debe escribir al menos 5 caracteres para buscar',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        })
        return
      }

      me.$vs.loading({ text: 'Buscando instituciones...' })

      try {
        const url = me.$server_url + 'listaInsitucionAsesor?busqueda=' + me.busquedaInstitucion + '&todasInstituciones=yes'
        const response = await me.$http.get(url)

        if (response.data.length > 0) {
          me.instituciones = response.data.map(inst => {
            return {
              id: inst.idInstitucion,
              nombre: inst.nombreInstitucion,
              ciudad: inst.ciudad || 'Sin ciudad',
              nombre_asesor: inst.nombre_asesor + " "+ inst.apellido_asesor || 'Sin asesor',
              tipo: 'normal'
            }
          })
        } else {
          me.instituciones = []
          me.$vs.notify({
            title: 'Información',
            text: 'No se encontraron instituciones',
            color: 'primary',
            iconPack: 'feather',
            icon: 'icon-info'
          })
        }
      } catch (error) {
        console.error('Error:', error)
        me.$vs.notify({
          title: 'Error',
          text: 'Error al buscar instituciones',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      } finally {
        me.$vs.loading.close()
      }
    },
    async cargarInstitucionesTemporales() {
      let me = this

      me.$vs.loading({ text: 'Cargando instituciones...' })

      try {
        const url = me.$server_url + 'listaInsitucionAsesor?temporales=yes&asesor_id=' + me.usuario.idusuario
        const response = await me.$http.get(url)

        if (response.data.length > 0) {
          me.instituciones = response.data.map(inst => {
            return {
              id: inst.institucion_temporal_id,
              nombre: inst.nombreInstitucion || inst.nombre_institucion, // Soportar ambos formatos
              ciudad: inst.ciudad || 'Sin ciudad',
              nombre_asesor: inst.nombre_asesor + " "+ inst.apellido_asesor || 'Sin asesor',
              periodo_id: inst.periodo_id,
              tipo: 'temporal'
            }
          })
        } else {
          me.instituciones = []
          me.$vs.notify({
            title: 'Información',
            text: 'No tiene instituciones temporales creadas',
            color: 'primary',
            iconPack: 'feather',
            icon: 'icon-info'
          })
        }
      } catch (error) {
        console.error('Error:', error)
        me.$vs.notify({
          title: 'Error',
          text: 'Error al cargar instituciones temporales',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      } finally {
        me.$vs.loading.close()
      }
    },
    seleccionarInstitucion(inst) {
      let me = this

      if (inst.tipo === 'normal') {
        me.formulario.institucion_id = inst.id
        me.formulario.institucion_id_temporal = null
        me.formulario.estado_institucion_temporal = 0
        me.formulario.nombre_institucion = inst.nombre
        me.formulario.periodo_id = null
      } else {
        me.formulario.institucion_id = null
        me.formulario.institucion_id_temporal = inst.id
        me.formulario.estado_institucion_temporal = 1
        me.formulario.nombre_institucion = inst.nombre
        me.formulario.periodo_id = inst.periodo_id
      }

      me.institucionSeleccionada = true
      me.instituciones = []
      me.busquedaInstitucion = ''

      me.$vs.notify({
        title: 'Éxito',
        text: 'Institución seleccionada correctamente',
        color: 'success',
        iconPack: 'feather',
        icon: 'icon-check'
      })
    },
    limpiarInstitucion() {
      this.formulario.institucion_id = null
      this.formulario.institucion_id_temporal = null
      this.formulario.estado_institucion_temporal = 0
      this.formulario.nombre_institucion = ''
      this.formulario.periodo_id = null
      this.institucionSeleccionada = false
      this.instituciones = []
      this.busquedaInstitucion = ''
    },
    async cargarCiudades() {
      let me = this
      try {
        const response = await me.$http.get(me.$server_url + 'ciudad')
        me.arregloCiudades = response.data
      } catch (error) {
        console.error('Error cargando ciudades:', error)
      }
    },
    async cargarPeriodos() {
      let me = this

      try {
        const response = await me.$http.get(me.$server_url + 'get_periodos_pedidos')
        // Mapear los períodos al formato esperado por el template
        me.arregloPeriodos = response.data
          .filter(p => p.estado == 1 && p.region_idregion == me.institucionTemporal.region)
          .map(p => ({
            id: p.idperiodoescolar,
            nombre: p.periodoescolar
          }))
        console.log('Períodos cargados:', me.arregloPeriodos)
      } catch (error) {
        console.error('Error cargando periodos:', error)
      }
    },
    abrirModalInstitucionTemporal() {
      this.mostrarFormularioTemporal = true
      // Cargar períodos por defecto (Costa = 2)
      this.cargarPeriodos()
    },
    async crearInstitucionTemporal() {
      let me = this

      if (!me.institucionTemporal.nombre || me.institucionTemporal.nombre.trim() === '') {
        me.$vs.notify({
          title: 'Validación',
          text: 'El nombre de la institución es obligatorio',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        })
        return
      }

      if (!me.institucionTemporal.ciudad) {
        me.$vs.notify({
          title: 'Validación',
          text: 'Debe seleccionar una ciudad',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        })
        return
      }

      if (!me.institucionTemporal.periodo) {
        me.$vs.notify({
          title: 'Validación',
          text: 'Debe seleccionar un periodo',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        })
        return
      }

      me.$vs.loading({ text: 'Creando institución...' })

      try {
        let formData = new FormData()
        formData.append('nombre_institucion', me.institucionTemporal.nombre)
        formData.append('ciudad', me.institucionTemporal.ciudad.nombre)
        formData.append('region', me.institucionTemporal.region)
        formData.append('periodo', me.institucionTemporal.periodo)
        formData.append('asesor_id', me.usuario.idusuario)

        const response = await me.$http.post(me.$server_url + 'GuardarInstitucionTemporal', formData)

        if (response.data.status === 0) {
          me.$vs.notify({
            title: 'Advertencia',
            text: response.data.message,
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-triangle'
          })
          return
        }

        me.formulario.institucion_id = null
        me.formulario.institucion_id_temporal = response.data.institucion_temporal_id
        me.formulario.estado_institucion_temporal = 1
        me.formulario.nombre_institucion = me.institucionTemporal.nombre
        me.formulario.periodo_id = response.data.periodo_id

        me.institucionSeleccionada = true
        me.mostrarFormularioTemporal = false
        me.institucionTemporal = {
          nombre: '',
          ciudad: null,
          region: '2',
          periodo: null
        }

        me.$vs.notify({
          title: 'Éxito',
          text: 'Institución temporal creada exitosamente',
          color: 'success',
          iconPack: 'feather',
          icon: 'icon-check'
        })
      } catch (error) {
        console.error('Error:', error)
        me.$vs.notify({
          title: 'Error',
          text: 'Error al crear institución temporal',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      } finally {
        me.$vs.loading.close()
      }
    },
    formatearFecha(fechaStr) {
      if (!fechaStr) return ''

      // Si la fecha viene en formato YYYY-MM-DD, parsearla manualmente para evitar timezone issues
      if (fechaStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const [year, month, day] = fechaStr.split('-').map(Number)
        const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
        return `${day.toString().padStart(2, '0')} ${meses[month - 1]} ${year}`
      }

      // Para otros formatos, usar el método anterior
      const fechaFormat = fechaStr.includes(' ') ? fechaStr.replace(' ', 'T') : fechaStr;
      const fecha = new Date(fechaFormat)

      if (isNaN(fecha.getTime())) return fechaStr;

      const opciones = {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      }
      return fecha.toLocaleDateString('es-ES', opciones)
    },
    obtenerIniciales(nombre) {
      if (!nombre) return '?'
      return nombre
        .split(' ')
        .map(n => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2)
    },
    obtenerEstadoTexto(estado) {
      const estados = {
        0: 'Generada',
        1: 'Registrada',
        2: 'Eliminado',
        3: 'No Realizada'
      }
      return estados[estado] || 'Desconocido'
    },
    obtenerEstadoNumerico(estadoTexto) {
      const estados = {
        'Generada': 0,
        'Registrada': 1,
        'Eliminado': 2,
        'No Realizada': 3
      }
      return estados[estadoTexto] || 0
    },
    calcularProgreso(estado) {
      const progresos = {
        0: 0,
        1: 100,
        2: 0,
        3: 0
      }
      return progresos[estado] || 0
    },
    async eliminarPlanificacion() {
      let me = this

      me.$vs.loading({ text: 'Eliminando planificación...' })

      try {
        const response = await me.$http.delete(
          me.$server_url + 'agenda-planificacion/' + me.formulario.id
        )

        if (response.data.success) {
          me.$vs.notify({
            title: 'Éxito',
            text: 'Planificación eliminada exitosamente',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check'
          })
          me.cerrarModal()
          me.cargarActividades()
        }
      } catch (error) {
        console.error('Error:', error)
        me.$vs.notify({
          title: 'Error',
          text: 'Error al eliminar la planificación',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      } finally {
        me.$vs.loading.close()
      }
    },
    async registrarUbicacionInicio() {
      let me = this

      if (!navigator.geolocation) {
        me.$vs.notify({
          title: 'Error',
          text: 'Tu navegador no soporta geolocalización',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
        return
      }

      me.$vs.loading({ text: 'Obteniendo ubicación...' })

      navigator.geolocation.getCurrentPosition(
        (position) => {
          me.formulario.latitud = position.coords.latitude
          me.formulario.longitud = position.coords.longitude
          // Enviar null y dejar que el backend genere la fecha/hora actual
          me.formulario.fecha_captura_longitud = null

          me.$vs.loading.close()
          me.$vs.notify({
            title: 'Éxito',
            text: 'Ubicación de inicio registrada correctamente',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check'
          })
        },
        (error) => {
          me.$vs.loading.close()
          me.$vs.notify({
            title: 'Error',
            text: 'No se pudo obtener la ubicación: ' + error.message,
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      )
    },
    async registrarUbicacionFin() {
      let me = this

      if(this.formulario.descripcion === null || this.formulario.descripcion === ''){
        me.$vs.notify({
          title: 'Error',
          text: 'Debe agregar una descripción de la actividad antes de registrar la ubicación final',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
        return
      }
      if (!navigator.geolocation) {
        me.$vs.notify({
          title: 'Error',
          text: 'Tu navegador no soporta geolocalización',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
        return
      }

      me.$vs.loading({ text: 'Obteniendo ubicación...' })

      navigator.geolocation.getCurrentPosition(
        (position) => {
          me.formulario.latitud_fin = position.coords.latitude
          me.formulario.longitud_fin = position.coords.longitude
          // Enviar null y dejar que el backend genere la fecha/hora actual
          me.formulario.fecha_captura_longitud_fin = null

          me.$vs.loading.close()
          me.$vs.notify({
            title: 'Éxito',
            text: 'Ubicación final registrada correctamente',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check'
          })
        },
        (error) => {
          me.$vs.loading.close()
          me.$vs.notify({
            title: 'Error',
            text: 'No se pudo obtener la ubicación: ' + error.message,
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      )
    },
    formatearFecha(fechaStr) {
      if (!fechaStr) return ''
      // Reemplazar espacio con 'T' para compatibilidad con navegadores
      const fechaFormat = fechaStr.includes(' ') ? fechaStr.replace(' ', 'T') : fechaStr;
      const fecha = new Date(fechaFormat + 'T00:00:00')

      if (isNaN(fecha.getTime())) return fechaStr;

      const opciones = {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      }
      return fecha.toLocaleDateString('es-ES', opciones)
    },
    formatearFechaHora(fechaISO) {
      if (!fechaISO) return ''

      // Si la fecha ya viene en formato SQL (YYYY-MM-DD HH:MM:SS), parsearla directamente
      let fecha;
      if (fechaISO.includes(' ')) {
        // Formato: 2026-02-27 17:12:00
        const partes = fechaISO.split(' ')
        const fechaParte = partes[0].split('-')
        const horaParte = partes[1].split(':')

        // Crear fecha sin conversión de zona horaria
        const year = parseInt(fechaParte[0])
        const month = parseInt(fechaParte[1]) - 1 // Los meses en JS van de 0-11
        const day = parseInt(fechaParte[2])
        const hour = parseInt(horaParte[0])
        const minute = parseInt(horaParte[1])

        // Formatear manualmente
        const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
        const diaFormateado = day.toString().padStart(2, '0')
        const mesFormateado = meses[month]
        const horaFormateada = hour.toString().padStart(2, '0')
        const minutoFormateado = minute.toString().padStart(2, '0')

        return `${diaFormateado} ${mesFormateado} ${year}, ${horaFormateada}:${minutoFormateado}`
      }

      // Si viene en formato ISO, usar el método anterior
      const fechaFormat = fechaISO.includes(' ') ? fechaISO.replace(' ', 'T') : fechaISO
      fecha = new Date(fechaFormat)

      if (isNaN(fecha.getTime())) return fechaISO

      const opciones = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }
      return fecha.toLocaleDateString('es-ES', opciones)
    },
    verEnGoogleMaps(lat, lng) {
      if (lat && lng) {
        const url = `https://www.google.com/maps?q=${lat},${lng}`
        window.open(url, '_blank')
      }
    },
    obtenerClaseEstado(estado) {
      const clases = {
        'Generada': 'generada',
        'Registrada': 'registrada',
        'Eliminado': 'eliminado',
        'No Realizada': 'norealizada'
      }
      return clases[estado] || 'generada'
    },
    async cargarCalendario() {
      let me = this

      // Solo cargar si el año cambió o es la primera carga
      if (me.calendarioYearCargado === me.calendarioYear) {
        return // Ya tenemos los datos de este año
      }

      try {
        const response = await me.$http.get(
          `${me.$server_url}agenda-planificacion/calendario?usuario_id=${me.usuario.idusuario}&year=${me.calendarioYear}`
        )

        if (response.data.success) {
          me.calendarioDatos = response.data.data
          me.calendarioYearCargado = me.calendarioYear
          console.log('Calendario cargado para año:', me.calendarioYear, me.calendarioDatos)
        }
      } catch (error) {
        console.error('Error cargando calendario:', error)
      }
    },
   mesAnterior() {
  if (this.calendarioMonth === 1) {
    this.calendarioMonth = 12
    this.calendarioYear--
  } else {
    this.calendarioMonth--
  }
  this.diaSeleccionado = null
  this.cargarActividades() // Recargar actividades del nuevo mes
},

mesSiguiente() {
  if (this.calendarioMonth === 12) {
    this.calendarioMonth = 1
    this.calendarioYear++
  } else {
    this.calendarioMonth++
  }
  this.diaSeleccionado = null
  this.cargarActividades() // Recargar actividades del nuevo mes
},

cambiarYear() {
  this.diaSeleccionado = null
  this.calendarioYearCargado = null
  this.cargarActividades() // Recargar actividades del nuevo año
},
    seleccionarDia(dia) {
      // Solo permitir seleccionar días del mes actual
      if (!dia.mesActual) return

      // Limpiar el filtro de estado al cambiar de día
      this.filtros.estadoSeleccionado = null

      // Siempre seleccionar el día clickeado (con o sin planificaciones)
      this.diaSeleccionado = dia.fecha
    }
  },
  created() {
    this.usuario = JSON.parse(localStorage.getItem('usuario'))
    this.cargarCiudades()
  },
  mounted() {
    // Determinar de dónde viene el usuario
    this.determinarUsuario()
    this.cargarActividades()
    this.cargarCalendario()
    // Cerrar dropdown al hacer click fuera
    document.addEventListener('click', this.cerrarMenuOpciones)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.cerrarMenuOpciones)
  }
}
</script>

<style scoped>
.planificaciones-dashboard {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #cbd5e1 100%);
  padding: 1rem;
}

/* Header */
.dashboard-header {
  margin-bottom: 2rem;
}

.header-content {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 1rem;
  padding: 1rem;
  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06);
  border: 1px solid rgba(148, 163, 184, 0.1);
  margin-bottom: 1rem;
}

.dashboard-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.75rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.025em;
}

.header-title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

@media (max-width: 640px) {
  .header-title-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .header-content {
    padding: 0.875rem;
    margin-bottom: 0.75rem;
  }
}

.btn-add-compact {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  background: linear-gradient(135deg, #1e40af 0%, #1d4ed8 100%);
  color: white;
  border: none;
  border-radius: 0.5rem;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 2px 8px rgba(30, 64, 175, 0.25);
}

.btn-add-compact:hover {
  background: linear-gradient(135deg, #1d4ed8 0%, #1e3a8a 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(30, 64, 175, 0.35);
}

.btn-add-compact:active {
  transform: translateY(0);
}

.btn-add-compact svg {
  width: 1.1rem;
  height: 1.1rem;
}

@media (max-width: 640px) {
  .btn-add-compact {
    width: 100%;
    justify-content: center;
    padding: 0.75rem 1rem;
  }
}

.title-icon {
  width: 2rem;
  height: 2rem;
  color: #1e40af;
}

.filters-container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
}

.filter-group {
  flex: 1;
  min-width: 200px;
}

.filter-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 0.5rem;
}

.filter-input {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #e2e8f0;
  border-radius: 0.5rem;
  font-size: 0.9375rem;
  transition: all 0.3s;
}

.filter-input:focus {
  outline: none;
  border-color: #1e40af;
  box-shadow: 0 0 0 3px rgba(30, 64, 175, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05);
}

.btn-clear-filters {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  background: #f7fafc;
  border: 2px solid #e2e8f0;
  border-radius: 0.5rem;
  color: #4a5568;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  height: fit-content;
  margin-top: auto;
}

.btn-clear-filters svg {
  width: 1.25rem;
  height: 1.25rem;
}

.btn-clear-filters:hover {
  background: #edf2f7;
  border-color: #cbd5e0;
}

.btn-reload-filters {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  background: linear-gradient(135deg, #1e40af 0%, #1d4ed8 100%);
  border: none;
  border-radius: 0.5rem;
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  height: fit-content;
  margin-top: auto;
  box-shadow: 0 2px 8px rgba(30, 64, 175, 0.2);
}

.btn-reload-filters svg {
  width: 1.25rem;
  height: 1.25rem;
}

.btn-reload-filters:hover {
  background: linear-gradient(135deg, #1d4ed8 0%, #2563eb 100%);
  box-shadow: 0 4px 12px rgba(30, 64, 175, 0.3);
  transform: translateY(-1px);
}

.btn-reload-filters:active svg {
  animation: spin 0.6s ease-in-out;
}

.btn-add-activity {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.5rem;
  background: linear-gradient(135deg, #1e40af 0%, #1d4ed8 100%);
  border: none;
  border-radius: 0.5rem;
  color: white;
  font-weight: 600;
  font-size: 0.9375rem;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 14px rgba(30, 64, 175, 0.2), 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  justify-content: center;
}

.btn-add-activity svg {
  width: 1.25rem;
  height: 1.25rem;
}

.btn-add-activity:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(30, 64, 175, 0.3), 0 4px 8px rgba(0, 0, 0, 0.15);
  background: linear-gradient(135deg, #1d4ed8 0%, #2563eb 100%);
}

.btn-add-activity:active {
  transform: translateY(0);
}

/* Estadísticas */
.stats-container-wrapper {
  position: relative;
}

.btn-toggle-stats-float {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  border: none;
  border-radius: 2rem;
  color: white;
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.4);
  z-index: 100;
}

.btn-toggle-stats-float:hover {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.5);
}

.btn-toggle-stats-float.stats-open {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
}

.btn-toggle-stats-float.stats-open:hover {
  background: linear-gradient(135deg, #b91c1c 0%, #991b1b 100%);
}

.btn-toggle-stats-float svg {
  width: 1.25rem;
  height: 1.25rem;
  transition: transform 0.3s;
}

.btn-toggle-stats-float .btn-text {
  display: inline;
}

@media (max-width: 640px) {
  .btn-toggle-stats-float {
    bottom: 1rem;
    right: 1rem;
    padding: 0.625rem 0.875rem;
    font-size: 0.8rem;
  }

  .btn-toggle-stats-float .btn-text {
    display: none; /* Ocultar texto en móvil, solo icono */
  }

  .btn-toggle-stats-float svg {
    width: 1.1rem;
    height: 1.1rem;
  }
}

/* Ocultar estadísticas por defecto en todas las resoluciones */
.stats-container {
  display: none !important;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.stats-container.stats-visible {
  display: grid !important;
  animation: slideDown 0.3s ease-out;
}

@media (max-width: 768px) {
  .stats-container {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.stat-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 1rem;
  padding: 1.25rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06);
  transition: all 0.3s;
  border: 1px solid rgba(148, 163, 184, 0.08);
  cursor: pointer;
  position: relative;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(15, 23, 42, 0.12), 0 2px 6px rgba(15, 23, 42, 0.08);
}

.stat-card-active {
  border: 2px solid #1e40af;
  box-shadow: 0 8px 25px rgba(30, 64, 175, 0.2), 0 2px 6px rgba(30, 64, 175, 0.15);
  transform: translateY(-4px);
}

.stat-card-active::after {
  content: '✓';
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  background: #1e40af;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: bold;
}

.stat-icon {
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  font-size: 1.5rem;
}

.stat-generada .stat-icon {
  background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
  color: #0369a1;
}

.stat-registrada .stat-icon {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #065f46;
}

.stat-eliminado .stat-icon {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #991b1b;
}

.stat-norealizada .stat-icon {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  color: #92400e;
}

.stat-content {
  display: flex;
  flex-direction: column;
}

.stat-value {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1a202c;
  line-height: 1;
}

.stat-label {
  font-size: 0.875rem;
  color: #718096;
  margin-top: 0.25rem;
}

/* Tablero de actividades */
.activities-board {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 1rem;
  padding: 1.5rem;
  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06);
  min-height: 400px;
  border: 1px solid rgba(148, 163, 184, 0.1);
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  color: #718096;
}

.spinner {
  width: 3rem;
  height: 3rem;
  border: 4px solid #e2e8f0;
  border-top-color: #1e40af;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  text-align: center;
  color: #718096;
}

.empty-state svg {
  width: 4rem;
  height: 4rem;
  margin-bottom: 1rem;
  color: #cbd5e0;
}

.empty-state h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #2d3748;
  margin: 0 0 0.5rem 0;
}

.empty-state p {
  margin: 0 0 1.5rem 0;
}

.btn-add-first {
  padding: 0.75rem 1.5rem;
  background: linear-gradient(135deg, #1e40af 0%, #1d4ed8 100%);
  border: none;
  border-radius: 0.5rem;
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 14px rgba(30, 64, 175, 0.25);
}

.btn-add-first:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(30, 64, 175, 0.35);
  background: linear-gradient(135deg, #1d4ed8 0%, #2563eb 100%);
}

.activities-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.25rem;
}

.activity-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 0.75rem;
  padding: 1rem;
  border-left: 4px solid;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.06), 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: all 0.3s;
  cursor: pointer;
  border: 1px solid rgba(148, 163, 184, 0.06);
}

.activity-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12), 0 4px 8px rgba(15, 23, 42, 0.08);
  border-color: rgba(148, 163, 184, 0.15);
}

.card-generada {
  border-left-color: #3b82f6;
  background: linear-gradient(to right, #eff6ff 0%, white 10%);
}

.card-registrada {
  border-left-color: #10b981;
  background: linear-gradient(to right, #ecfdf5 0%, white 10%);
}

.card-eliminado {
  border-left-color: #ef4444;
  background: linear-gradient(to right, #fef2f2 0%, white 10%);
}

.card-norealizada {
  border-left-color: #f59e0b;
  background: linear-gradient(to right, #fffbeb 0%, white 10%);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.625rem;
  border-radius: 9999px;
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.badge-dot {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.badge-generada {
  background: #e0f2fe;
  color: #0369a1;
}

.badge-generada .badge-dot {
  background: #3b82f6;
}

.badge-registrada {
  background: #d1fae5;
  color: #065f46;
}

.badge-registrada .badge-dot {
  background: #10b981;
}

.badge-eliminado {
  background: #fee2e2;
  color: #991b1b;
}

.badge-eliminado .badge-dot {
  background: #ef4444;
}

.badge-norealizada {
  background: #fef3c7;
  color: #92400e;
}

.badge-norealizada .badge-dot {
  background: #f59e0b;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.btn-menu {
  padding: 0.25rem;
  background: transparent;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  border-radius: 0.25rem;
  transition: all 0.2s;
}

.btn-menu:hover {
  background: #f3f4f6;
  color: #4b5563;
}

.btn-menu svg {
  width: 1.25rem;
  height: 1.25rem;
}

/* Dropdown Menu */
.dropdown-menu-container {
  position: relative;
}

.dropdown-menu-list {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.25rem;
  background: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15), 0 2px 6px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  min-width: 160px;
  z-index: 50;
  overflow: hidden;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  width: 100%;
  padding: 0.625rem 1rem;
  border: none;
  background: transparent;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  text-align: left;
}

.dropdown-item svg {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
}

.dropdown-item-edit {
  color: #1e40af;
}

.dropdown-item-edit:hover {
  background: #eff6ff;
  color: #1d4ed8;
}

.dropdown-item-delete {
  color: #dc2626;
}

.dropdown-item-delete:hover {
  background: #fef2f2;
  color: #b91c1c;
}

.dropdown-item-norealizada {
  color: #d97706;
}

.dropdown-item-norealizada:hover {
  background: #fffbeb;
  color: #b45309;
}

/* Dropdown transition */
.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: all 0.15s ease;
}

.dropdown-fade-enter,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px) scale(0.95);
}

/* Confirm Delete Popup */
.confirm-delete-body {
  text-align: center;
  padding: 1rem 0;
}

.confirm-delete-icon {
  width: 4rem;
  height: 4rem;
  margin: 0 auto 1rem;
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.confirm-delete-icon svg {
  width: 2rem;
  height: 2rem;
  color: #dc2626;
}

.confirm-norealizada-icon {
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%) !important;
}

.confirm-norealizada-icon svg {
  color: #d97706 !important;
}

.confirm-delete-body h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 0.5rem 0;
}

.confirm-delete-body p {
  font-size: 0.9375rem;
  color: #64748b;
  margin: 0 0 1.5rem 0;
  line-height: 1.5;
}

.confirm-delete-actions {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
}

.card-body {
  margin-bottom: 0.75rem;
}

.card-title {
  font-size: 0.9375rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 0.375rem 0;
  line-height: 1.3;
}

.card-description {
  font-size: 0.95rem;
  color: #718096;
  margin: 0 0 0.75rem 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.card-description1 {
  font-size: 0.75rem;
  color: #718096;
  margin: 0 0 0.75rem 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-meta {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #4a5568;
}

.meta-item svg {
  width: 1rem;
  height: 1rem;
  color: #9ca3af;
}

.meta-item-inline {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #4a5568;
  flex-wrap: wrap;
}

.meta-item-inline svg {
  width: 1rem;
  height: 1rem;
  color: #9ca3af;
}

.meta-item-inline .separator {
  color: #cbd5e1;
  font-weight: 600;
  margin: 0 0.25rem;
}

.card-footer {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
}

.avatar-group {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.avatar {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: linear-gradient(135deg, #1e40af 0%, #1d4ed8 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.75rem;
  box-shadow: 0 2px 8px rgba(30, 64, 175, 0.25);
}

.avatar-name {
  font-size: 0.875rem;
  color: #4a5568;
  font-weight: 500;
}

.card-progress {
  margin-top: 1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.progress-bar {
  flex: 1;
  height: 0.5rem;
  background: #e2e8f0;
  border-radius: 9999px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #1e40af 0%, #1d4ed8 100%);
  border-radius: 9999px;
  transition: width 0.3s;
  box-shadow: 0 1px 3px rgba(30, 64, 175, 0.3);
}

.progress-text {
  font-size: 0.75rem;
  font-weight: 600;
  color: #4a5568;
  min-width: 3rem;
  text-align: right;
}

/* Popup Planificación (vs-popup) */
.popup-body-planificacion,
.popup-body-temporal {
  padding: 1.5rem;
}

.popup-footer-planificacion {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  padding: 1.5rem 0 0 0;
  border-top: 1px solid #e2e8f0;
  margin-top: 1.5rem;
}

.form-group {
  margin-bottom: 1.25rem;
}

.form-group label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
}

.form-input,
.form-textarea,
.form-select {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #e2e8f0;
  border-radius: 0.5rem;
  font-size: 0.9375rem;
  transition: all 0.3s;
  font-family: inherit;
}

.form-input:focus,
.form-textarea:focus,
.form-select:focus {
  outline: none;
  border-color: #1e40af;
  box-shadow: 0 0 0 3px rgba(30, 64, 175, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05);
}

.form-textarea {
  resize: vertical;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.opciones-titulo {
  font-size: 1rem !important;
  font-weight: 700 !important;
  color: #1e40af !important;
  margin-bottom: 0.25rem !important;
}

.opciones-subtitulo {
  font-size: 0.75rem;
  color: #64748b;
  margin-bottom: 1rem;
}

.opciones-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.875rem;
}

@media (max-width: 1024px) {
  .opciones-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0.75rem;
  border: 2px solid #e2e8f0;
  border-radius: 0.5rem;
  transition: all 0.3s;
  background: white;
}

.checkbox-label:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}

.checkbox-label input[type="checkbox"] {
  width: 1.125rem;
  height: 1.125rem;
  margin-right: 0.625rem;
  cursor: pointer;
  accent-color: #1e40af;
}

.checkbox-label span {
  font-size: 0.875rem;
  color: #334155;
  font-weight: 500;
}

.checkbox-label input[type="checkbox"]:checked + span {
  color: #1e40af;
  font-weight: 600;
}

.ubicacion-section {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 2px solid #e2e8f0;
}

.ubicacion-buttons {
  display: flex;
  flex-direction: column;
  gap: 0.875rem;
}

.btn-ubicacion {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 0.5rem;
  background: white;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: 600;
  font-size: 0.875rem;
  color: #334155;
}

.btn-ubicacion:not(:disabled):hover {
  border-color: #1e40af;
  background: #f8fafc;
  transform: translateX(4px);
}

.btn-ubicacion svg {
  width: 1.5rem;
  height: 1.5rem;
  color: #1e40af;
}

.btn-ubicacion-pendiente {
  border-color: #1e40af;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  color: #1e40af;
}

.btn-ubicacion-registrado {
  border-color: #10b981;
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  color: #059669;
  cursor: not-allowed;
}

.btn-ubicacion-registrado svg {
  color: #10b981;
}

.btn-ubicacion:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.ubicacion-info {
  margin-top: 1rem;
  padding: 1rem;
  background: #f8fafc;
  border-radius: 0.5rem;
  border: 1px solid #e2e8f0;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 0.75rem;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-item strong {
  color: #1e40af;
  font-size: 0.875rem;
}

.info-item span {
  font-size: 0.875rem;
  color: #64748b;
}

.fecha-captura {
  font-size: 0.75rem !important;
  color: #94a3b8 !important;
  font-style: italic;
}

.ubicacion-status {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid rgba(148, 163, 184, 0.15);
}

.ubicacion-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
}

.icon-ubicacion {
  width: 1rem;
  height: 1rem;
  color: #64748b;
}

.ubicacion-registrada {
  color: #10b981;
  font-weight: 600;
}

.ubicacion-sin-registrar {
  color: #f59e0b;
  font-weight: 500;
}

/* Selector de tipo de filtro */
.filtro-tipo-selector {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 1rem;
  background: white;
  border-radius: 0.75rem;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
  border: 1px solid rgba(148, 163, 184, 0.1);
}

@media (max-width: 640px) {
  .filtro-tipo-selector {
    flex-direction: column;
    gap: 0.75rem;
    padding: 0.75rem;
    margin-bottom: 0.75rem;
  }
}

.radio-option {
  flex: 1;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  border: 2px solid #e2e8f0;
  background: white;
  transition: all 0.2s;
}

@media (max-width: 640px) {
  .radio-option {
    padding: 0.625rem 0.75rem;
  }
}

.radio-option:hover {
  border-color: #3b82f6;
  background: #f0f9ff;
}

.radio-option input[type="radio"] {
  margin-right: 0.75rem;
  width: 1.25rem;
  height: 1.25rem;
  cursor: pointer;
  accent-color: #3b82f6;
}

@media (max-width: 640px) {
  .radio-option input[type="radio"] {
    width: 1.1rem;
    height: 1.1rem;
    margin-right: 0.5rem;
  }
}

.radio-option input[type="radio"]:checked + .radio-label {
  color: #1e40af;
  font-weight: 600;
}

.radio-option:has(input[type="radio"]:checked) {
  border-color: #3b82f6;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.95rem;
  color: #475569;
  transition: all 0.2s;
}

@media (max-width: 640px) {
  .radio-label {
    font-size: 0.875rem;
    gap: 0.375rem;
  }
}

.radio-label svg {
  width: 1.25rem;
  height: 1.25rem;
  color: #64748b;
}

@media (max-width: 640px) {
  .radio-label svg {
    width: 1.1rem;
    height: 1.1rem;
  }
}

.radio-option:has(input[type="radio"]:checked) .radio-label svg {
  color: #3b82f6;
}

/* Calendario Compacto */
.calendario-compacto {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 1rem;
  padding: 0.75rem;
  margin-bottom: 0.75rem;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06);
  border: 1px solid rgba(148, 163, 184, 0.1);
  width: 100%;
}

@media (max-width: 640px) {
  .calendario-compacto {
    padding: 0.625rem;
    margin-bottom: 0.5rem;
    border-radius: 0.75rem;
  }
}

.calendario-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e2e8f0;
}

@media (max-width: 640px) {
  .calendario-header {
    margin-bottom: 0.5rem;
    padding-bottom: 0.375rem;
  }
}

.mes-year-selector {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
}

.mes-actual {
  font-size: 1rem;
  font-weight: 700;
  color: #1e40af;
  text-align: center;
}

@media (max-width: 640px) {
  .mes-actual {
    font-size: 0.9rem;
  }
}

.year-select {
  padding: 0.25rem 0.5rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.375rem;
  background: white;
  color: #475569;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
}

.year-select:hover {
  border-color: #3b82f6;
  background: #f0f9ff;
}

.year-select:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

@media (max-width: 640px) {
  .year-select {
    font-size: 0.7rem;
    padding: 0.2rem 0.4rem;
  }
}

.btn-nav-mes {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  border: none;
  border-radius: 0.5rem;
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
}

.btn-nav-mes:hover {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);
}

.btn-nav-mes svg {
  width: 1.25rem;
  height: 1.25rem;
}

@media (max-width: 640px) {
  .btn-nav-mes {
    padding: 0.4rem;
  }

  .btn-nav-mes svg {
    width: 1.1rem;
    height: 1.1rem;
  }
}

.filtro-dia-activo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  margin-bottom: 0.75rem;
  border: 1px solid #bae6fd;
}

.texto-filtro {
  font-size: 0.8rem;
  font-weight: 600;
  color: #1e40af;
}

.btn-limpiar-dia {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  background: white;
  border: 1px solid #3b82f6;
  border-radius: 0.375rem;
  color: #1e40af;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-limpiar-dia:hover {
  background: #1e40af;
  color: white;
}

.btn-limpiar-dia svg {
  width: 0.875rem;
  height: 0.875rem;
}

.mes-actual {
  font-size: 1rem;
  font-weight: 700;
  color: #1e40af;
  letter-spacing: -0.025em;
}

.btn-nav-mes {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border: none;
  background: #eff6ff;
  border-radius: 0.5rem;
  color: #1e40af;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-nav-mes:hover {
  background: #dbeafe;
  transform: scale(1.1);
}

.btn-nav-mes svg {
  width: 1rem;
  height: 1rem;
}

.calendario-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.15rem;
}

.dia-semana {
  text-align: center;
  font-size: 0.65rem;
  font-weight: 600;
  color: #64748b;
  padding: 0.25rem 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.dia-mes {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 0.4rem;
  cursor: pointer;
  transition: all 0.2s;
  background: white;
  border: 1px solid transparent;
  height: 2.75rem;
  z-index: 1;
}

@media (max-width: 640px) {
  .dia-mes {
    height: 2.5rem;
    border-radius: 0.3rem;
  }
}

@media (max-width: 480px) {
  .dia-mes {
    height: 2.25rem;
  }
}

.dia-mes:hover {
  background: #f8fafc;
  transform: scale(1.05);
  z-index: 5;
}

.dia-otro-mes {
  opacity: 0.3;
  cursor: default;
  pointer-events: none;
}

.dia-otro-mes:hover {
  background: white;
  transform: none;
}

.dia-hoy {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border-color: #3b82f6;
  font-weight: 700;
}

.dia-seleccionado {
  background: linear-gradient(135deg, #1e40af 0%, #1d4ed8 100%) !important;
  color: white !important;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(30, 64, 175, 0.3);
  transform: scale(1.1);
  z-index: 10;
}

.dia-seleccionado .numero-dia {
  color: white !important;
  font-weight: 700 !important;
}

.dia-seleccionado .punto-indicador {
  background: white !important;
}

.dia-seleccionado .numero-planificaciones {
  background: rgba(255, 255, 255, 0.9) !important;
  color: #1e40af !important;
  font-weight: 600 !important;
}

.dia-con-planificaciones {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-color: #bae6fd;
}

.dia-con-planificaciones:hover {
  background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
  border-color: #7dd3fc;
}

.numero-dia {
  font-size: 0.75rem;
  font-weight: 500;
  color: #1e293b;
  z-index: 1;
}

@media (max-width: 640px) {
  .numero-dia {
    font-size: 0.7rem;
  }
}

@media (max-width: 480px) {
  .numero-dia {
    font-size: 0.65rem;
  }
}

.indicador-planificaciones {
  position: absolute;
  bottom: 0.15rem;
  display: flex;
  align-items: center;
  gap: 0.1rem;
}

@media (max-width: 640px) {
  .indicador-planificaciones {
    bottom: 0.1rem;
    gap: 0.075rem;
  }
}

.punto-indicador {
  width: 0.35rem;
  height: 0.35rem;
  background: #3b82f6;
  border-radius: 50%;
  animation: pulse-dot 2s infinite;
}

.punto-indicador.multiple {
  width: 0.45rem;
  height: 0.45rem;
  background: #1e40af;
}

.numero-planificaciones {
  font-size: 0.6rem;
  font-weight: 700;
  color: #1e40af;
  background: white;
  border-radius: 0.25rem;
  padding: 0.0625rem 0.2rem;
  line-height: 1;
}

@keyframes pulse-dot {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.2);
  }
}

/* Chips de estadísticas dentro del calendario */
.stats-chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
}

.stat-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: 1.5px solid transparent;
}

.chip-dot {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  flex-shrink: 0;
}

.chip-label {
  flex: 1;
}

.chip-value {
  font-weight: 700;
  font-size: 0.875rem;
  padding: 0.125rem 0.375rem;
  border-radius: 0.375rem;
  background: rgba(255, 255, 255, 0.5);
}

/* Chip Generada */
.stat-chip-generada {
  background: #e0f2fe;
  color: #0369a1;
}

.stat-chip-generada .chip-dot {
  background: #3b82f6;
}

.stat-chip-generada:hover {
  background: #bae6fd;
  transform: translateY(-1px);
}

.stat-chip-generada.stat-chip-active {
  background: #0369a1;
  color: white;
  border-color: #0369a1;
}

.stat-chip-generada.stat-chip-active .chip-value {
  background: rgba(255, 255, 255, 0.2);
}

/* Chip Registrada */
.stat-chip-registrada {
  background: #d1fae5;
  color: #065f46;
}

.stat-chip-registrada .chip-dot {
  background: #10b981;
}

.stat-chip-registrada:hover {
  background: #a7f3d0;
  transform: translateY(-1px);
}

.stat-chip-registrada.stat-chip-active {
  background: #065f46;
  color: white;
  border-color: #065f46;
}

.stat-chip-registrada.stat-chip-active .chip-value {
  background: rgba(255, 255, 255, 0.2);
}

/* Chip Eliminado */
.stat-chip-eliminado {
  background: #fee2e2;
  color: #991b1b;
}

.stat-chip-eliminado .chip-dot {
  background: #ef4444;
}

.stat-chip-eliminado:hover {
  background: #fecaca;
  transform: translateY(-1px);
}

.stat-chip-eliminado.stat-chip-active {
  background: #991b1b;
  color: white;
  border-color: #991b1b;
}

.stat-chip-eliminado.stat-chip-active .chip-value {
  background: rgba(255, 255, 255, 0.2);
}

/* Chip No Realizada */
.stat-chip-norealizada {
  background: #fef3c7;
  color: #92400e;
}

.stat-chip-norealizada .chip-dot {
  background: #f59e0b;
}

.stat-chip-norealizada:hover {
  background: #fde68a;
  transform: translateY(-1px);
}

.stat-chip-norealizada.stat-chip-active {
  background: #92400e;
  color: white;
  border-color: #92400e;
}

.stat-chip-norealizada.stat-chip-active .chip-value {
  background: rgba(255, 255, 255, 0.2);
}

@media (max-width: 640px) {
  .stats-chips-container {
    gap: 0.375rem;
  }

  .stat-chip {
    font-size: 0.6875rem;
    padding: 0.3rem 0.625rem;
    gap: 0.3rem;
  }

  .chip-dot {
    width: 0.4rem;
    height: 0.4rem;
  }

  .chip-value {
    font-size: 0.75rem;
    padding: 0.0625rem 0.3rem;
  }
}

/* Responsive */
@media (max-width: 768px) {
  .planificaciones-dashboard {
    padding: 0.75rem;
  }

  .header-content {
    padding: 1rem;
  }

  .dashboard-title {
    font-size: 1.5rem;
  }

  .title-icon {
    width: 1.75rem;
    height: 1.75rem;
  }

  .filters-container {
    flex-direction: column;
  }

  .filter-group {
    min-width: 100%;
  }

  .btn-clear-filters {
    width: 100%;
    justify-content: center;
  }

  .stats-container {
    grid-template-columns: 1fr;
  }

  .activities-grid {
    grid-template-columns: 1fr;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .opciones-grid {
    grid-template-columns: 1fr;
  }

  .checkbox-label {
    padding: 0.625rem;
  }

  .popup-body-planificacion,
  .popup-body-temporal {
    padding: 1rem;
  }

  .institucion-search {
    max-height: 400px;
  }

  .search-type-buttons {
    flex-direction: column;
  }

  .temporal-actions {
    flex-direction: column;
  }
}

/* Estilos del componente de institución */
.institucion-section {
  margin-bottom: 1.5rem;
  margin-bottom: 1.5rem;
  padding: 1.25rem;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 50%, #bfdbfe 100%);
  border-radius: 0.75rem;
  border: 2px solid #3b82f6;
}

.institucion-search {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.inst-tipo-selector {
  display: flex;
  gap: 0.5rem;
}

.inst-tipo-btn {
  flex: 1;
}

.search-box {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.btn-buscar-inst {
  align-self: center;
}

.temporal-actions {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}


.instituciones-list {
  max-height: 300px;
  overflow-y: auto;
  border: 2px solid #e2e8f0;
  border-radius: 0.5rem;
  background: white;
}

.list-header {
  padding: 0.75rem 1rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.875rem;
  font-weight: 600;
  color: #64748b;
}

.institucion-item {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  padding: 1rem;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  transition: all 0.2s;
}

.institucion-item:last-child {
  border-bottom: none;
}

.institucion-item:hover {
  background: #f8fafc;
  transform: translateX(4px);
}

.inst-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border-radius: 0.5rem;
  color: #1e40af;
}

.inst-icon svg {
  width: 1.5rem;
  height: 1.5rem;
}

.inst-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.inst-nombre {
  font-weight: 600;
  color: #1e293b;
  font-size: 0.9375rem;
}

.inst-detalle {
  font-size: 0.8125rem;
  color: #64748b;
}

.inst-arrow {
  color: #cbd5e1;
}

.inst-arrow svg {
  width: 1.25rem;
  height: 1.25rem;
}

.institucion-selected {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.selected-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem;
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  border: 2px solid #10b981;
  border-radius: 0.75rem;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.15);
}

.selected-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  background: white;
  border-radius: 0.5rem;
  color: #10b981;
}

.selected-icon svg {
  width: 2rem;
  height: 2rem;
}

.selected-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.selected-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #059669;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.selected-name {
  font-size: 1.125rem;
  font-weight: 700;
  color: #064e3b;
}

.selected-type {
  font-size: 0.8125rem;
  color: #047857;
}

.btn-remove-inst {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  background: white;
  border: 2px solid #f87171;
  border-radius: 0.5rem;
  color: #ef4444;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-remove-inst svg {
  width: 1.25rem;
  height: 1.25rem;
}

.btn-remove-inst:hover {
  background: #fef2f2;
  border-color: #dc2626;
  color: #dc2626;
  transform: rotate(90deg);
}


.form-help {
  margin-top: 0.5rem;
  font-size: 0.75rem;
  color: #64748b;
  font-style: italic;
}

/* Responsive */
@media (max-width: 768px) {
  .planificaciones-dashboard {
    padding: 0.75rem;
  }

  .header-content {
    padding: 1rem;
  }

  .dashboard-title {
    font-size: 1.5rem;
  }

  .title-icon {
    width: 1.75rem;
    height: 1.75rem;
  }

  .filters-container {
    flex-direction: column;
  }

  .filter-group {
    min-width: 100%;
  }

  .btn-clear-filters {
    width: 100%;
    justify-content: center;
  }

  .stats-container {
    grid-template-columns: 1fr;
  }

  .activities-grid {
    grid-template-columns: 1fr;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .opciones-grid {
    grid-template-columns: 1fr;
  }

  .checkbox-label {
    padding: 0.625rem;
  }

  .popup-body-planificacion,
  .popup-body-temporal {
    padding: 1rem;
  }

  .institucion-search {
    max-height: 400px;
  }

  .search-type-buttons {
    flex-direction: column;
  }

  .temporal-actions {
    flex-direction: column;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .activities-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mapa de ubicación */
.ubicacion-info {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-top: 1rem;
}

.mapa-ubicacion-container {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 0.75rem;
  overflow: hidden;
}

.mapa-ubicacion-container.mapa-fin {
  background: #eff6ff;
  border-color: #bfdbfe;
}

.mapa-header {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
}

.mapa-header div {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.mapa-header strong {
  font-size: 0.875rem;
  color: #0f172a;
}

.mapa-header small {
  font-size: 0.75rem;
  color: #64748b;
}

.mapa-header small.fecha-captura {
  color: #94a3b8;
  font-style: italic;
}

.mapa-icon {
  width: 1.5rem;
  height: 1.5rem;
  color: #16a34a;
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.mapa-fin .mapa-icon {
  color: #2563eb;
}

.mapa-embed {
  height: 250px;
  border-top: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
}

.mapa-embed iframe {
  display: block;
}

.mapa-actions {
  display: flex;
  justify-content: center;
  padding: 0.625rem 1rem;
  gap: 0.5rem;
}

.btn-ver-mapa {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 1rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #ffffff;
  background: #16a34a;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-ver-mapa:hover {
  background: #15803d;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(22, 163, 74, 0.3);
}

.btn-ver-mapa svg {
  width: 1rem;
  height: 1rem;
}

.mapa-fin .btn-ver-mapa {
  background: #2563eb;
}

.mapa-fin .btn-ver-mapa:hover {
  background: #1d4ed8;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);
}
</style>

<style>
.popup-planificacion {
  z-index: 50003 !important;
}
.popup-temporal {
  z-index: 50006 !important;
}
</style>
